import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { blue, gold, orange, textMuted } from '@/theme/colors'
import { radii } from '@/theme/tokens'
import { fontSizes } from '@/theme/typography'

/** Created trips fill orange and joined ones gold, in the bar and its key alike. */
const tripFill = ({ $joined }: { $joined?: boolean }) => ($joined ? gold : orange)

export const StepRow = styled.div`
	display: grid;
	grid-template-columns: minmax(96px, 18%) 1fr minmax(150px, 22%);
	align-items: center;
	gap: 16px;
	padding: 8px 0;
`

export const StepLabel = styled.span`
	font-size: ${fontSizes.small};
	font-weight: 700;
	color: ${blue};
`

/** Holds one fill, or two side by side where a step is split. */
export const StepTrack = styled.div`
	display: flex;
	height: 18px;
	border-radius: ${radii.round};
	background-color: ${textMuted}14;
	overflow: hidden;
`

export const StepFill = styled.div<{ $width: number; $joined?: boolean }>`
	flex: none;
	width: ${({ $width }) => `${$width}%`};
	background-color: ${tripFill};
`

export const StepValue = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
	font-size: ${fontSizes.small};
	font-variant-numeric: tabular-nums;
`

export const StepCount = styled.span`
	font-weight: 700;
	color: ${blue};
`

/** A step count that opens the list of who it counts. */
export const StepCountLink = styled(Link)`
	align-self: flex-start;
	font-weight: 700;
	color: ${blue};
	text-decoration: underline;
	text-decoration-color: ${textMuted}66;
	text-underline-offset: 3px;

	&:hover {
		text-decoration-color: ${blue};
	}
`

export const StepDetail = styled.span`
	color: ${textMuted};
`

/** The created/joined key under the split step, in the bar column. */
export const SplitKey = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	font-size: ${fontSizes.small};
	color: ${textMuted};
`

export const KeySwatch = styled.span<{ $joined?: boolean }>`
	display: inline-block;
	width: 10px;
	height: 10px;
	margin-right: 6px;
	border-radius: ${radii.tiny};
	background-color: ${tripFill};
`

export const ExcludedList = styled.ul`
	margin: 16px 0 0;
	padding-left: 18px;
	font-size: ${fontSizes.small};
	color: ${textMuted};
`
